import { useRef, useState } from "react";
import useStorage from "../hooks/useStorage";
import BotCard from "../components/BotCard";

function parseBot(code) {
  return eval("const obj = " + code + "\nobj");
}

export default function BotManager({ onStart }) {
  const [bots, setBots] = useStorage("bots", []);
  const [dragging, setDragging] = useState(false);
  const inputRef = useRef();

  const loadFile = (file) => {
    if (!file || !file.name.endsWith(".js")) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const code = ev.target.result;
        const bot = parseBot(code);
        setBots((prev) => [
          ...prev,
          {
            id: crypto.randomUUID(),
            code,
            config: bot.config,
            funds: 100,
          },
        ]);
      } catch (err) {
        alert("Ошибка загрузки бота: " + err.message);
      }
    };
    reader.readAsText(file);
  };

  const handleFileInput = (e) => {
    loadFile(e.target.files[0]);
    e.target.value = "";
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    Array.from(e.dataTransfer.files).forEach(loadFile);
  };

  const handleDelete = (id) => {
    setBots((prev) => prev.filter((b) => b.id !== id));
  };

  const handleFundsChange = (id, funds) => {
    setBots((prev) => prev.map((b) => (b.id === id ? { ...b, funds } : b)));
  };

  return (
    <div className="BotManager">
      <div className="BotManager-Title">Poker for AI</div>
      <div
        className={"BotManager-List" + (dragging ? " Dragging" : "")}
        onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
        onDragLeave={() => setDragging(false)}
        onDrop={handleDrop}
        onClick={() => bots.length === 0 && inputRef.current.click()}
      >
        {bots.length === 0 ? (
          <div className="BotManager-DropHint">
            <div className="BotManager-DropIcon">↓</div>
            <div>Перетащите .js файлы сюда</div>
            <div className="BotManager-DropSub">или нажмите «+ Добавить бота»</div>
          </div>
        ) : (
          bots.map((bot) => (
            <BotCard
              key={bot.id}
              bot={bot}
              onDelete={handleDelete}
              onFundsChange={handleFundsChange}
            />
          ))
        )}
      </div>
      <div className="BotManager-Actions">
        <input
          ref={inputRef}
          type="file"
          accept=".js"
          multiple
          style={{ display: "none" }}
          onChange={handleFileInput}
        />
        <button
          className="BotManager-Btn"
          onClick={() => inputRef.current.click()}
        >
          + Добавить бота
        </button>
        <button
          className="BotManager-Btn Primary"
          disabled={bots.length < 2}
          onClick={() => onStart(bots)}
        >
          Начать игру
        </button>
      </div>
    </div>
  );
}
